const scope_0 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/05b606b8cda6eefc5b71b2223fe42e85.js').default;
const scope_1 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/3dc6475665bc24553d65745ef37c7549.js').default;
const scope_2 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/e43fb7ea8e5c973fc291302acf6043f3.js').default;export default {
  ...scope_0,
...scope_1,
...scope_2
}